import { EmployeeRoles } from '../model/inko-backend.model'

/**
 * Ob diese Rollen die Oberfläche des Leistungserbringers öffnen: Navigation, Startseite und
 * `leistungserbringerGuard`.
 *
 * **Gespiegelt aus dem Backend** (`SanitaetshausEmployeeRole#mitgebrachteRollen`): der
 * Callcenter-Agent bringt dort `LEISTUNGSERBRINGER` mit und besteht damit jedes
 * `hasRole('LEISTUNGSERBRINGER')`. Gespeichert ist an ihm aber nur `CALLCENTER_AGENT`, und genau das
 * liefert `currentlyloggedin`. Ein nacktes `roles.includes('LEISTUNGSERBRINGER')` sperrte ihn also
 * aus einer Oberfläche aus, deren Endpunkte ihn längst durchlassen. Ändert sich die Mitnahme im
 * Backend, wird sie hier nachgezogen.
 */
export function wirktAlsLeistungserbringer(roles: readonly EmployeeRoles[]): boolean {
  return roles.includes('LEISTUNGSERBRINGER') || roles.includes('CALLCENTER_AGENT')
}
